import { createDomain, sample } from 'effector'
import { interval } from 'patronum'
import { AxiosErrorType, Driver } from '~/shared/api'
import { CarAccessControlEnum } from '~/shared/config/enums'
import { mapMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain('entities.rentalContract.carAccessControl')

export const carAccessControl = domain.createEvent<CarAccessControlEnum>()
export const carAccessControlFx = domain.createEffect<
  CarAccessControlEnum,
  CarAccessControlEnum,
  AxiosErrorType
>({
  handler: async (command) => {
    await Driver.carAccessControl(command)
    return command
  },
})

sample({
  clock: carAccessControl,
  target: carAccessControlFx,
})

sample({
  clock: carAccessControlFx.doneData,
  fn: (command) => {
    const message =
      command === CarAccessControlEnum.LOCK
        ? 'Команда на блокировку отправлена'
        : 'Команда на разблокировку отправлена'
    return { message, variant: 'success' as const }
  },
  target: snackbarEnqueued,
})

sample({
  clock: carAccessControlFx.failData,
  fn: (e) => ({
    message: mapMessageErrors(e),
    variant: 'danger' as const,
  }),
  target: snackbarEnqueued,
})

export const resetCarAccessControlLoading = domain.createEvent()
export const $isCarAccessControlLoading = domain
  .createStore(false)
  .on(carAccessControl, () => true)
  .on([carAccessControlFx.failData, resetCarAccessControlLoading], () => false)

const timer = interval({
  timeout: 15000,
  start: carAccessControl,
  leading: false,
  trailing: false,
})

sample({
  clock: timer.tick,
  target: resetCarAccessControlLoading,
})
